import { render } from "./reportPreInfo.vue?vue&type=template&id=39627467"
import script from "./reportPreInfo.vue?vue&type=script&lang=js"
export * from "./reportPreInfo.vue?vue&type=script&lang=js"

import "./reportPreInfo.vue?vue&type=style&index=0&id=39627467&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__